import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Layout,
  Typography,
  Card,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Spin,
} from "antd";
import { useNavigate } from "react-router-dom";

// PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import { BOM } from "../../../services/definedMethod";
import { apiConfig,staticConfig } from "../systemAdmin.config";
import cnt from "../../../services/definedConstant";

const { Content } = Layout;
const { Text, Title } = Typography;

const ViewEmailService = (props) => {
  const { userData, rightAction  } = props;
  const { session } = userData;

  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getEmailServiceConfig();
  }, []);

  useEffect(() => {
      BOM.HasPermission("READ_BOND") ;
      BOM.HasPermission("CREATE_BOND");
       BOM.HasPermission("CREATE_BOND") && dispatch({ type: cnt.RIGHT_EDIT_BTN });
    }, []);
  
  const getEmailServiceConfig = () => {
    setIsLoading(true);

    const url = `${apiConfig.ExternalServiceEmail}/SMTP`; // adjust endpoint if needed
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        // ✅ Convert array of { name, value } to an object
        const formatted = (res || []).reduce((acc, item) => {
          acc[item.name] = item.value;
          return acc;
        }, {});

        // ✅ Map values to form
        form.setFieldsValue({
          host: formatted.host,
          port: formatted.port,
          useTLS: formatted.useTLS === "true", // convert to boolean
          fromName: formatted.fromName,
          username: formatted.username,
          password: formatted.password,
          fromEmail: formatted.fromEmail,
        });

        setIsLoading(false);
      }
    });
  };

  function handleOnEdit() {
      navigate("/edit-sya2700");
  }
  const onCancel = () => {
    navigate("/sya2700");
  };

  return (
    <MainLayout
     isEnableRightSidebar={true}
      onEdit={handleOnEdit}
     >
      <TopContent
        pageTitle={"View Email Service Configuration"}
        pageItems={staticConfig.viewExternalNotifcationEmailBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" disabled>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item name="host" label={<Text strong>Host</Text>}>
                    <Input placeholder="SMTP Host" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="port" label={<Text strong>Port</Text>}>
                    <Input placeholder="Port Number" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="useTLS"
                    valuePropName="checked"
                    label={<Text strong>Use TLS</Text>}
                  >
                    <Checkbox>Enable TLS</Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item name="fromName" label={<Text strong>From Name</Text>}>
                    <Input placeholder="From Name" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item name="username" label={<Text strong>Username</Text>}>
                    <Input placeholder="Username" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item name="password" label={<Text strong>Password</Text>}>
                    <Input.Password placeholder="Password" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item name="fromEmail" label={<Text strong>From Email</Text>}>
                    <Input placeholder="From Email" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* <Form.Item>
              <Row justify="end">
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item> */}
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(ViewEmailService);
